import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["symbolField", "pointsField", "icon"];

  update() {
    const symbol = this._symbolValue();
    const points = this._pointsValue();

    this.iconTargets.forEach((icon) => {
      const matches = icon.dataset.symbol === symbol && Number(icon.dataset.index) <= points;

      icon.classList.toggle('hidden', !matches);
    });
  }

  _symbolValue() {
    return this.symbolFieldTarget.querySelector('input[type="hidden"]')?.value;
  }

  _pointsValue() {
    return Number(this.pointsFieldTarget.querySelector('input[type="hidden"]')?.value);
  }
}
